/**
 * @desc 查询附近售后网点
 */

import { RequestConfig, request } from 'umi';

function req(
  data: defs.store.AfterSaleStoreQueryVO,
  config: Parameters<typeof request>[1] = {},
) {
  return request<defs.store.WrapResponse<Array<defs.store.AfterSaleStoreVO>>>(
    `/storeapi/after/sale/store/nearby`,
    {
      data,
      method: 'post',
      ...(config || {}),
    },
  );
}
req.req = {} as Parameters<typeof req>[0];
req.res = {} as defs.store.WrapResponse<Array<defs.store.AfterSaleStoreVO>>;
export default req;
